export default {"src":"/_next/static/media/aetna-logo.7f8d401f.svg","height":28,"width":105,"blurWidth":0,"blurHeight":0};